var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-right":"4px","display":"inline-flex","flex-wrap":"wrap"}},[_c('img',{staticClass:"d-image",attrs:{"src":_vm.mainUrl,"alt":""},on:{"click":_vm.handleClick}}),(_vm.showLightBox)?_c('light-box',{attrs:{"media":_vm.media},on:{"onClosed":_vm.onClosed}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }